module.exports = __webpack_public_path__ + "img/1530867368.55f9d773.jpg";